import { Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { getSnpBookNews } from './BookNewsApiServices';
import SnpBookList from './SnpBookList';

function BookNewsSNP({ htmlBlog = '' }) {
  const [bookGroups, setBookGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    getSnpBookNews()
      .then((res) => {
        setBookGroups(res);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const bookList = useMemo(() => {
    const currentGroup = bookGroups[selectedTabIndex];
    return currentGroup ? currentGroup.ListBooks : [];
  }, [selectedTabIndex, bookGroups]);

  return (
    <section className="books-news">
      <div className="container">
        <div className="bg-white px-3 py-4">
          <div className="mb-3">
            <h2 className="mb-0">
              <span className="text-heading">Giới thiệu sách</span>
            </h2>
            <div className="border-bottom pt-3" />
          </div>
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-01-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-01"
                type="button"
                role="tab"
                aria-controls="pills-01"
                aria-selected="true"
                onClick={() => {
                  setSelectedTabIndex(0);
                }}
              >
                Giới thiệu sách
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-02-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-02"
                type="button"
                role="tab"
                aria-controls="pills-02"
                aria-selected="false"
                onClick={() => {
                  setSelectedTabIndex(1);
                }}
              >
                Sách mới
              </button>
            </li>
          </ul>

          <div className="row">
            <div className="col-xl-8 order-xl-2">
              {isLoading ? (
                <Spin />
              ) : (
                <div>
                  {bookGroups.length ? (
                    <SnpBookList books={bookList.slice(0, 12)} />
                  ) : (
                    <i>No data</i>
                  )}
                </div>
              )}
            </div>
            <div className="col-xl-4">
              <div
                className="book-news__html-blog"
                dangerouslySetInnerHTML={{
                  __html: htmlBlog,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BookNewsSNP;
